import { useState, Fragment } from "react"
import kebabCase from "lodash/kebabCase"
import classNames from "classnames"

import { useTranslation } from "lib/i18n/translation"
import { useMainCategories, listComponent } from "lib/tools/categories"
import SkeletonLink from "components/common/skeleton-link"
import { baseProduct } from "components/common/skeleton"
import image, { DIRECTOR_AVATAR } from "lacinetek-common/src/images"
import Image from "components/common/image"
import ProductThumb from "components/common/product-thumb"
import fullname from "lib/tools/name"

export default ({ product, others, loading, isSvod }) => {
	const { c } = useTranslation("common")
	const { allLists } = useMainCategories()

	const categories = [
		{ title: product.directorGender === "Femme"
			? c("from-the-same-director-female")
			: c("from-the-same-director"),
			products: []
		},
		{ title: c("from-the-same-year"), products: [] },
		{ title: c("with-the-same-actors"), products: [] }
	]

	if (loading || !others) {
		categories.forEach((c, index) => categories[index].products = [baseProduct, baseProduct, baseProduct])
		categories[2].products = categories[2].products.map(p => ({ title: "Lorem ipsum dolor", products: [baseProduct, baseProduct, baseProduct, baseProduct]}))
	} else {
		categories[0].products = others.director
		categories[1].products = others.year
		categories[2].products = others.actors
	}

	if (categories.filter(c => c.products.length > 0).length == 0) return null

	return (
		<section
			className={classNames({
				"grey": !isSvod,
				"tvod-color": isSvod
			})}
		>
			<h2 className="section-title icon-favorite-alt">
				{c(isSvod ? "svod-other-films-strong" : "other-films-strong")}
			</h2>
			<ul className="see-also columns">
				<li>
					{ [categories[0]].filter(c => c.products.length > 0).map((category, index) => (
							<Category key={`others-0-${index}`} category={category} c={c} loading={loading} />
					))}


					{ product.year && [categories[1]].filter(c => c.products.length > 0 && c).map((category, index) => (
							<Category key={`others-1-${index}`} category={category} c={c} loading={loading} />
					))}
				</li>
				{ categories[2].products.length
					? <li>
							<h3>{categories[2].title.split(" ").slice(0, categories[2].title.split(" ").length - 1).join(" ")} <b>{categories[2].title.split(" ")[categories[2].title.split(" ").length - 1]}</b></h3>
							{ categories[2].products.map((actor, index) => (
								<Category key={`others-2-${index}`} category={actor} c={c} loading={loading} sub={true} />
							))}
						</li>
					: null
				}
			</ul>
			<ul className="see-also columns">
				{ product.recommendersIds.length > 0
					? <li>
							<h3>{c("film-recommended-by")}</h3>
							<ul className={`grid min directors ${loading ? "skel-loading" : ""}`}>
								{ product.recommendersIds.map((id, index) => {
										const list = allLists.find(l => l.director.id == id)

										if (!list) {
											return null
										}

										return (
											<li key={`others-film-recommended-by-${index}`} className="item">
												<SkeletonLink href={`/lists/[id]`} as={`/lists/${list.linkRewrite}`} >
													<a title={c("see-film-single")} className="item-content">
														<figure className="avatar skel">
															<picture>
																<Image src={image(list.director, DIRECTOR_AVATAR)} alt={`${list.firstname} ${list.lastname}`} />
															</picture>
														</figure>
														<div className="infos skel">
															<h3 className="title-alt">{fullname(list)}</h3>
														</div>
													</a>
												</SkeletonLink>
											</li>
										)
								})}
							</ul>
						</li>
					: null
				}
				{ product.inMovements && product.inMovements.length > 0
					? <li>
							{ product.inMovements.map((movement, index) => (
									<Fragment key={`in-movement-${index}`}>
										<h3>{c("film-in-movement")} <b>{c("movement")}</b></h3>
										<h4 className="title">"{movement.name}"</h4>
										<p>
											<SkeletonLink href={{ pathname: "/films", query: { movement: encodeURIComponent(JSON.stringify(movement)) } }}>
												<a title={c("see-movement-films-list")} className="button">{c("see-movement-films-list")}</a>
											</SkeletonLink>
										</p>
									</Fragment>
							))}
						</li>
					: null
				}
			</ul>
		</section>
	)
}

const Category = ({category, c, loading, sub}) => {
	const [complete, setComplete] = useState(false)
	const products = complete ? category.products : category.products.slice(0, 3)

	return (
		<>
			{ sub
				? <h4 className="title-alt">{listComponent({name: category.title}, true)}</h4>
				: <h3>{category.title.split(" ").slice(0, category.title.split(" ").length - 1).join(" ")} <b>{category.title.split(" ")[category.title.split(" ").length - 1]}</b></h3>
			}
			{ category.products.length > 3
				? <a href="#" onClick={e => { e.preventDefault(); setComplete(!complete) }} rel="nofollow noopener" title="Voir la liste complète" className={`collapsible-toggle button small simple icon-${complete ? "less" : "more"}`}>{c(complete ? "see-less-films" : "see-more-films")}</a>
				: null
			}
			<ul className={`grid min films ${loading ? "skel-loading" : ""}`}>
				{ products.map((product, index) => (
						<ProductThumb key={`category-${kebabCase(category.title)}-${index}`} product={product} loading={loading} tiny={true} />
				))}
			</ul>
		</>
	)
}
